import InfoForm from './InfoForm';

export default InfoForm;
